import { styled } from "goober";
import { FooterBadge } from "./FooterBadge";
import { ToggleButton } from "./HeadingToggle";
import { Icon } from "./Icon";
import { Text } from "./Text";
import { Tooltip } from "./Tooltip";

const FooterRow = styled("div")`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export function CodeDiffFooter({
  fileCount,
  fileIndex,
  diffCount,
  diffIndex,
  goPrevFile,
  goNextFile,
  goPrevDiff,
  goNextDiff,
}: {
  fileCount: number;
  fileIndex: number;
  diffCount: number;
  diffIndex: number;
  goPrevFile: () => void;
  goNextFile: () => void;
  goPrevDiff: () => void;
  goNextDiff: () => void;
}) {
  return (
    <>
      {fileCount >= 2 ? (
        <FooterRow>
          <FooterBadge>
            <Text variant="text-small-md" color="var(--text-primary)">
              Files
            </Text>
            <Text variant="text-small" color="var(--text-secondary)">
              {fileIndex >= 0 ? fileIndex + 1 : 0} / {fileCount}
            </Text>
          </FooterBadge>
          <Tooltip content="Previous file">
            <ToggleButton aria-label="Previous file" onPress={goPrevFile}>
              <Icon name="arrow-up" size={12} />
            </ToggleButton>
          </Tooltip>
          <Tooltip content="Next file">
            <ToggleButton aria-label="Next file" onPress={goNextFile}>
              <Icon name="arrow-down" size={12} />
            </ToggleButton>
          </Tooltip>
        </FooterRow>
      ) : (
        <div />
      )}
      <FooterRow>
        <FooterBadge>
          <Text variant="text-small-md" color="var(--text-primary)">
            Diffs
          </Text>
          <Text variant="text-small" color="var(--text-secondary)">
            {diffCount === 0 ? 0 : diffIndex + 1} / {diffCount}
          </Text>
        </FooterBadge>
        <Tooltip
          content={
            <>
              Previous diff{" "}
              <span
                style={{
                  fontSize: 10,
                  color: "var(--tooltip-fg-muted)",
                  marginLeft: 4,
                }}
              >
                P
              </span>
            </>
          }
        >
          <ToggleButton
            aria-label="Previous diff"
            onPress={goPrevDiff}
            disabled={diffCount === 0}
          >
            <Icon name="arrow-up" size={12} />
          </ToggleButton>
        </Tooltip>
        <Tooltip
          content={
            <>
              Next diff{" "}
              <span
                style={{
                  fontSize: 10,
                  color: "var(--tooltip-fg-muted)",
                  marginLeft: 4,
                }}
              >
                N
              </span>
            </>
          }
        >
          <ToggleButton
            aria-label="Next diff"
            onPress={goNextDiff}
            disabled={diffCount === 0}
          >
            <Icon name="arrow-down" size={12} />
          </ToggleButton>
        </Tooltip>
      </FooterRow>
    </>
  );
}
